import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AuthForm } from "./AuthForm";
import { SocialAuth } from "./SocialAuth";

export function AuthTabs() {
  return (
    <Tabs defaultValue="signin" className="w-full">
      <TabsList className="grid w-full grid-cols-2 mb-8">
        <TabsTrigger value="signin">Sign In</TabsTrigger>
        <TabsTrigger value="signup">Sign Up</TabsTrigger>
      </TabsList>

      <TabsContent value="signin" className="space-y-4">
        <div className="text-center">
          <h1 className="text-2xl font-semibold tracking-tight">Welcome back</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Enter your credentials to access your account
          </p>
        </div>
        <AuthForm mode="signin" />
        <SocialAuth />
      </TabsContent>

      <TabsContent value="signup" className="space-y-4">
        <div className="text-center">
          <h1 className="text-2xl font-semibold tracking-tight">Create an account</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Enter your details to create your account
          </p>
        </div>
        <AuthForm mode="signup" />
        <SocialAuth />
      </TabsContent>
    </Tabs>
  );
}